import { render, staticRenderFns } from "./MaterialGroup.vue?vue&type=template&id=692cc173"
import script from "./MaterialGroup.vue?vue&type=script&lang=js"
export * from "./MaterialGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports